import { IIcons } from "@/types";

const DorasIcons: IIcons[] = [
    {
        value: "DorasIconLight",
        img: "https://cdn.doras.to/doras/icons/light/doras.webp",
    },
    {
        value: "DorasIconDark",
        img: "https://cdn.doras.to/doras/icons/dark/doras.webp",
    },
    {
        value: "DorasThroneIconLight",
        img: "https://cdn.doras.to/doras/icons/light/throne.webp",
    },
    {
        value: "DorasThroneIconDark",
        img: "https://cdn.doras.to/doras/icons/dark/throne.webp",
    },
    {
        value: "DorasPixLight",
        img: "https://cdn.doras.to/doras/icons/light/pix.webp",
    },
    {
        value: "DorasPixDark",
        img: "https://cdn.doras.to/doras/icons/dark/pix.webp",
    },
    {
        value: "DorasStreamerBotLight",
        img: "https://cdn.doras.to/doras/icons/light/sb.webp",
    },
    {
        value: "DorasStreamerBotDark",
        img: "https://cdn.doras.to/doras/icons/dark/sb.webp",
    },
    {
        value: "DorasTrovoLight",
        img: "https://cdn.doras.to/doras/icons/light/trovo.png",
    },
    {
        value: "DorasTrovoDark",
        img: "https://cdn.doras.to/doras/icons/dark/trovo.png",
    },
];
export default DorasIcons;
